export default "__VITE_ASSET__Bjv7OTZA__"